<template>
    <v-container class="prinCon" fluid>
        <div class="prin">
            <div class="logo">
                <div>
                    <v-img alt="logo" class="icon" src="../assets/img/logo-letters-icon.svg"></v-img>
                </div>
                <h2 class="date text-white">{{ formattedDate }}</h2>
            </div>
            <div class="log_in">
                <v-card class="contenedor">
                    <H1 style="color:#4d78c7; display: flex; justify-content: center; ">Bienvenido</H1>
                    <H1 style="color:#4d78c7; display: flex; justify-content: center; margin-bottom: 50px;">Inicia Sesion
                    </H1>

                    <!-- solo aparece en modo movil -->
                    <div class="logo_movil_contenedor">
                        <v-img alt="logo" src="../assets/img/compliance-logo.svg" class="logo_movil"></v-img>
                    </div>

                    <v-card-title class="text-h6 font-weight-regular justify-space-between">

                        <span>{{ currentTitle }}</span>
                    </v-card-title>

                    <v-window v-model="step" class="steps">
                        <v-window-item :value="1">
                            <v-card-text>
                                <v-text-field label="Email" clearable variant="solo-filled"
                                    v-model="UserLoginInfo.email"></v-text-field>
                                <span class="text-caption text-grey-darken-1">
                                    This is the email you will use to login to your account
                                </span>
                            </v-card-text>
                        </v-window-item>

                        <v-window-item :value="2">
                            <v-card-text>
                                <v-text-field label="Password" type="password" clearable variant="solo-filled"
                                    v-model="UserLoginInfo.password"></v-text-field>
                                <span class="text-caption text-grey-darken-1">
                                    Enter a password for your account
                                </span>
                            </v-card-text>
                        </v-window-item>
                    </v-window>

                    <v-card-actions>
                        <v-btn v-if="step > 1" @click="step--" elevation="4" color="error" variant="flat"
                            append-icon="mdi mdi-window-close">
                            Cancelar
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn v-if="step < 2" @click="step++" elevation="4" color="success" variant="flat"
                            append-icon="mdi mdi-chevron-right">
                            Siguiente
                        </v-btn>
                        <v-btn v-if="step == 2" elevation="4" append-icon="mdi mdi-login" color="success" variant="flat"
                            @click="login">
                            Login
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </div>
        </div>
    </v-container>
</template>
<style>
.prinCon,
.prin {
    width: 100%;
    height: 100%;
    background: linear-gradient(315deg, #000000, #4792ff);
    display: flex;
}

.logo,
.log_in {
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
}

.icon {
    margin-top: 130px;
    max-width: 550px;
    max-height: 550px;
}

.logo {
    flex-direction: column;
}

.contenedor {
    width: 540px;
    height: 650px;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.session-form {
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* Estilos para pantallas menores a 768px (normalBar oculto, movilBar visible) */
@media screen and (max-width: 767px) {
    .logo {
        display: none;
    }

    .log_in {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .contenedor {
        width: 450px;
        height: 650px;
        display: flex;
        align-items: center;
    }

    .v-text-field {
        width: 300px;
    }

    .logo_movil,
    .logo_movil_contenedor {
        width: 100px;
        height: 100px;
    }
}

/* Estilos para pantallas mayores o iguales a 768px (normalBar visible, movilBar oculto) */
@media screen and (min-width: 768px) {
    .logo_movil {
        display: none;
    }
}
</style>

<script>
// import {
//     ref,
//     getStorage,
//     uploadBytes,
//     getDownloadURL,
//     listAll,
// } from "firebase/storage";
// import { db, collection, addDoc, getDocs } from "../../firebase/index.js";

import { ref } from '@firebase/database';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import Swal from "sweetalert2";

export default {


    data() {
        return {
            currentDate: new Date(),
            step: 1,

            UserLoginInfo: {
                email: "",
                password: "",

            }
        };
    },

    methods: {
        async login() {
            try {
                const auth = getAuth();
                const userCredential = await signInWithEmailAndPassword(auth, this.UserLoginInfo.email, this.UserLoginInfo.password);

                const user = userCredential.user;

                user.getIdToken().then((idToken) => {
                    console.log('Firebase ID Token:', idToken);
                    // Puedes guardar el ID Token en localStorage o en el estado de la aplicación
                    // También puedes enviar el token al servidor para realizar autenticación en el servidor
                });

                // Resto del código después del inicio de sesión...

                // Redirecciona al usuario después del inicio de sesión
                this.$router.push('/dashboard');
            } catch (error) {
                let errorMessage = 'Ha ocurrido un error. Por favor, inténtalo de nuevo.';

                // Verifica el código de error específico de Firebase
                switch (error.code) {
                    case 'auth/user-not-found':
                        errorMessage = 'Usuario no registrado. Por favor, regístrate primero.';
                        break;
                    case 'auth/wrong-password':
                        errorMessage = 'Contraseña incorrecta. Por favor, verifica tu contraseña.';
                        break;
                        case 'auth/invalid-email':
                        errorMessage = 'Email incorrecto. Por favor, verifica tu Email.';
                        break;
                    case 'auth/too-many-requests':
                        errorMessage = 'Demasiados intentos. Por favor, espera un momento antes de intentarlo de nuevo.';
                        break;
                    // Puedes agregar más casos según los códigos de error de Firebase que desees manejar
                    default:
                        break;
                }

                // Muestra el mensaje de error con SweetAlert
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: errorMessage,
                    footer: 'Descuida, inténtalo de nuevo o comunícate con tu proveedor',
                });

                console.error('Error al iniciar sesión:', error.message);
            }
        },
    },

    computed: {
        currentTitle() {
            switch (this.step) {
                case 1:
                    return "Correo";
                case 2:
                    return "Contraseña";
            }
        },
        formattedDate() {
            const options = {
                weekday: "long",
                day: "numeric",
                month: "long",
                year: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: true,
            };

            return this.currentDate.toLocaleString("es-ES", options);
        },
    },
    mounted() {
        // Actualizar la fecha cada segundo
        this.timer = setInterval(() => {
            this.currentDate = new Date();
        }, 1000);
    },
    beforeDestroy() {
        // Limpiar el intervalo al destruir el componente
        clearInterval(this.timer);
    },
};
</script>
